// extracted by mini-css-extract-plugin
module.exports = {"selected":"generalSearchTagsMobile_selected__16O5n","container-tags":"generalSearchTagsMobile_container-tags__3qDsk","expand":"generalSearchTagsMobile_expand__CIp7p"};